import { useTranslation } from "react-i18next";

const GivenName = ({
  givenNameIsValid,
  givenName,
  setGivenName,
  label,
  required,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <label>
        {label}
        {required && <span>*</span>}
      </label>
      <input
        type="text"
        value={givenName}
        onChange={(evt) => {
          setGivenName(evt.target.value);
        }}
        {...props}
      />
      {!givenNameIsValid && (
        <div className="valid-message">{t("auth.givenName.validMessage")}</div>
      )}
    </div>
  );
};

export default GivenName;
